// extracted by mini-css-extract-plugin
module.exports = {"wrap-input":"FormListPassword_wrap-input__Jo3JG","wrap-check":"FormListPassword_wrap-check__gkM9E"};